import { combineReducers } from "redux";
import areas from './areas';
import filters from './filters';

export default combineReducers({ areas, filters });